export default __webpack_public_path__ + "static/media/ticketing-system-mockup.6c6a310d.PNG";